"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSuccessResult = exports.getErrors = exports.isResultWithErrors = void 0;
var webClientResponse_1 = require("../requester/webClientResponse");
function isResultWithErrors(result) {
    return !!result.errors;
}
exports.isResultWithErrors = isResultWithErrors;
function getErrors(res) {
    return isResultWithErrors(res.result) ? res.result.errors : [];
}
exports.getErrors = getErrors;
function getSuccessResult(response) {
    if (webClientResponse_1.WebClientResponseHelper.isErrorResponse(response)) {
        return Promise.reject(response);
    }
    var result = response.response.result;
    if (isResultWithErrors(result)) {
        return Promise.reject(response);
    }
    return Promise.resolve(result);
}
exports.getSuccessResult = getSuccessResult;
//# sourceMappingURL=vizPortalWebClientHelpers.js.map